// Opaque, per-tab identifier. Sent with every tRPC request as the `x-client-id`
// header; the server stamps it onto the `app.client_id` GUC so trip-change DB
// triggers echo it back in their broadcast payload. The trip-data subscription
// then ignores broadcasts bearing this id — i.e. our own writes' echo. It's a
// random nonce tied to no user, safe to put on the public broadcast channel.
export const CLIENT_ID =
  typeof crypto !== `undefined` && `randomUUID` in crypto
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2)
